import BillDetails from '../../../../bills/components/details/BillDetails';

export default function BillDetailsScreen() {
    return <BillDetails />;
}
